module.exports = __webpack_public_path__ + "img/head.72f59864.png";